import { useEffect, useState } from "react";
import { BookOpen, Download, ExternalLink } from "lucide-react";
import { catalogUrl, fetchCatalogs } from "@/lib/bf";

export const useBrandCatalogs = (brand) => {
  const [list, setList] = useState([]);
  useEffect(() => { fetchCatalogs().then((l) => setList(l.filter((x) => x.brand === brand && !x.group))).catch(() => {}); }, [brand]);
  return list;
};

const HAS_IMG = new Set(["mvchart2024", "frfocus3", "frmorph", "mvlung", "mvscalp", "mvchoice", "lalgaro", "sonoro", "plmedavita", "plframesi", "pllalga", "plsono", "plsonocat", "plmowan"]);

export default function BFCatalogBanner({ catalogs }) {
  if (!catalogs.length) return null;
  return (
    <div className="bf-catbanner-wrap bf-catgrid" data-testid="bf-catbanner">
      {catalogs.map((k, i) => (
        <div key={k.id} className="bf-catbanner bf-catcard" style={{ animationDelay: `${i * 0.6}s` }} data-testid={`bf-catbanner-${k.id}`}>
          <a href={catalogUrl(k.id)} target="_blank" rel="noopener noreferrer" className="bf-catcard-art" aria-label={`Deschide ${k.title}`} data-testid={`bf-catcard-art-${k.id}`}>
            {HAS_IMG.has(k.id) ? <img src={`/catalog-tiles/${k.id}-v5.jpg`} alt="" loading="lazy" /> : <span className="bf-catbanner-icon"><BookOpen size={34} /></span>}
          </a>
          <div className="bf-catbanner-text">
            <b>{k.title}</b>
            <small>{k.id?.startsWith("pl") ? "Prețuri de listă cu TVA" : "Vezi ce face fiecare produs, înainte să comanzi"} · PDF{k.size ? ` · ${Math.round(k.size / 1048576)} MB` : ""}</small>
          </div>
          <div className="bf-catbanner-actions">
            <a href={catalogUrl(k.id)} target="_blank" rel="noopener noreferrer" className="is-main" data-testid={`bf-catbanner-open-${k.id}`}><ExternalLink size={16} /> Deschide</a>
            <a href={`${catalogUrl(k.id)}?dl=1`} data-testid={`bf-catbanner-download-${k.id}`}><Download size={16} /> Descarcă</a>
          </div>
        </div>
      ))}
    </div>
  );
}
